import { Routes } from '@angular/router';

export const PUSH_NOTIFICATIONS_ROUTES: Routes = [
  {
    path: 'push-notifications',
    loadComponent: () =>
      import('./push-notifications-list/push-notifications-list.component')
        .then(m => m.PushNotificationsListComponent),
  },
  {
    path: 'push-notifications/create',
    loadComponent: () =>
      import('./push-notifications-form/push-notifications-form.component')
        .then(m => m.PushNotificationsFormComponent),
  },
  {
    path: 'push-notifications/edit/:id',
    loadComponent: () =>
      import('./push-notifications-form/push-notifications-form.component')
        .then(m => m.PushNotificationsFormComponent),
  },
];
